<template>
  <div>
    <Card>
      <ui-chevron
        :color="$colors.black"
        :open="false"
      ></ui-chevron>
    </Card>
    <Card>
      <ui-chevron
        :color="$colors.green"
        :open="true"
      ></ui-chevron>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { useColors } from '@/composables';

const $colors = useColors();
</script>
